import {EntityKey} from './entity';

export class EntityBreak {

  key!: EntityKey;
  sequenceNumber!: number;
  priceEffect!: string;
  price!: number;
  createTimestamp!: Date;
  createUser!: string;
  extendedAmount!: number;
  factorCode!: string;
  updateTimestamp!: Date;
  updateUser!: string;

}
